// extracted by mini-css-extract-plugin
export var active = "_63-2";
export var container = "_63-0";
export var expired = "_63-3";
export var hasStatus = "_63-4";
export var statusChip = "_63-1";